export const ALLOWED_FILE_TYPES =
  /(.pdf|.exr|.heic|.tiff|.jp2|.jpeg|.sig|.jpg|.png|.doc|.docx|.xls|.xlsx|.txt|.rar|.zip|.7z|.tar-gz|.tgz|.zipx|.gzip|.gz)$/;
